import React from 'react'

const SvgTennisOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M19.972 12.678a8.098 8.098 0 00-.03-1.636 8.84 8.84 0 01-6.978-6.978 8.083 8.083 0 00-1.636-.03 10.445 10.445 0 008.644 8.644zM12.671 19.979a10.444 10.444 0 00-8.643-8.644 8.1 8.1 0 00.03 1.636 8.84 8.84 0 016.977 6.978 8.082 8.082 0 001.636.03z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.563 4.218a10.247 10.247 0 008.225 8.225 8.002 8.002 0 00-.028-1.234 9.042 9.042 0 01-6.963-6.962 7.895 7.895 0 00-1.234-.029zm-.251-.383a8.304 8.304 0 011.676.03l.145.018.028.143a8.64 8.64 0 006.82 6.82l.142.027.018.145a8.295 8.295 0 01.03 1.676l-.017.215-.213-.034a10.645 10.645 0 01-8.81-8.81l-.034-.212.215-.018zm-7.466 7.269l.213.034a10.645 10.645 0 018.81 8.81l.034.212-.215.018a8.325 8.325 0 01-1.677-.03l-.144-.018-.028-.143a8.64 8.64 0 00-6.82-6.82l-.143-.027-.017-.145a8.282 8.282 0 01-.03-1.676l.017-.216zm.366.466a7.93 7.93 0 00.028 1.234 9.042 9.042 0 016.962 6.962 7.901 7.901 0 001.235.028 10.246 10.246 0 00-8.225-8.225z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z'
    />
  </svg>
)

export default SvgTennisOutline
